export const NAV_LINKS = ['Home', 'Projects', 'About', 'Gallery', 'Contact'];

export const STATS = [
  { n: '500+', l: 'Happy Customers' },
  { n: '6',    l: 'Prime Locations' },
  { n: '20+',  l: 'Successful Projects' },
  { n: '8+',   l: 'Years of Experience' },
];

import { IMG_COIMBATORE, IMG_IMG2, IMG_IMG3, IMG_IMG4, IMG_IMG5, IMG_IMG6, IMG_TIRUNELVELI } from '../assets/cityImages';

export const CITIES = [
  { name: 'Coimbatore',  tag: 'COIMBATORE',  tagline: 'Manchester of the South',  plots: '14 Plots Available', price: 'From ₹799/sq.ft',      badge: 'DTCP Approved',    img: IMG_COIMBATORE },
  { name: 'Tirunelveli', tag: 'TIRUNELVELI', tagline: 'City of Temples',           plots: '9 Plots Available',  price: 'From ₹499/sq.ft',      badge: 'DTCP Approved',    img: IMG_TIRUNELVELI },
  { name: 'Tuticorin',   tag: 'TUTICORIN',   tagline: 'Pearl City of India',       plots: '11 Plots Available', price: 'From ₹650/sq.ft',      badge: 'DTCP Approved',    img: IMG_IMG2 },
  { name: 'Chennai',     tag: 'CHENNAI',     tagline: 'Capital of the South',      plots: '22 Plots Available', price: 'From ₹1,800/sq.ft',    badge: 'Premium Location', img: IMG_IMG3 },
  { name: 'Singapore',   tag: 'SINGAPORE',   tagline: 'Lion City — NRI Pick',      plots: '6 Units Available',  price: 'From SGD 1,200/sq.ft', badge: 'NRI Friendly',     img: IMG_IMG4 },
  { name: 'Malaysia',    tag: 'MALAYSIA',    tagline: 'Selangor · Kuala Lumpur',   plots: '8 Units Available',  price: 'From MYR 280/sq.ft',   badge: 'Freehold',         img: IMG_IMG5 },
];

export const TESTIMONIALS = [
  { name: 'Rajesh Kumar', city: 'Chennai',    role: 'Software Engineer', stars: 5, text: 'Bought a plot in Vandalur through Elaris. The legal process was super smooth, documentation crystal clear.' },
  { name: 'Priya Nair',   city: 'Coimbatore', role: 'Business Owner',    stars: 5, text: 'Elaris delivered everything they promised. DTCP approval, bank loan, on time. Highly recommended!' },
  { name: 'Suresh Babu',  city: 'Malaysia',   role: 'NRI Investor',      stars: 5, text: 'As an NRI, the Elaris NRI desk made everything seamless from Malaysia. Truly professional team.' },
];

export const FAQS = [
  { q: 'Are all plots DTCP approved?',                 a: 'Yes. Every plot we sell carries valid DTCP approval from the relevant local body. We also hold RERA registration (PRM/TN/RERA/1251/310/2024/003).' },
  { q: 'Can I get a bank loan for purchasing a plot?', a: 'Absolutely. Our plots are pre-approved by SBI, HDFC, ICICI Bank and more. You can get up to 80% financing.' },
  { q: 'Do you have NRI-friendly investment options?', a: 'Yes. We have a dedicated NRI Desk that handles FEMA compliance, repatriation of funds, and remote legal documentation.' },
  { q: 'What is the minimum plot size available?',     a: 'Minimum plot sizes start at 1000 sq.ft in select locations. Premium and villa plots start from 2000 sq.ft.' },
  { q: 'How do I book a site visit?',                  a: 'Click Book Free Site Visit anywhere on this page. Our advisor will call you within 2 hours to schedule a convenient time.' },
];

export const WHY_BADGES = [
  { emoji: '🏛️', label: '100%\nDTCP & RERA\nApproved' },
  { emoji: '🏦', label: 'Bank Loan\nUp to 80%' },
  { emoji: '🔒', label: 'Secure\nInvestments' },
  { emoji: '📄', label: 'Clear Titles\n& Documents' },
  { emoji: '🎧', label: 'Dedicated After\nSales Support' },
];
